import { Country } from '../types';
import { ALIAS_MAP } from '../constants';

// Normalize input string: remove diacritics, lowercase, trim
export const normalize = (str: string): string => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
};

export const searchCountries = (query: string, countries: Country[]): Country[] => {
  if (!query) return [];
  const normalizedQuery = normalize(query);
  
  // Check explicit aliases first (e.g., "UAE" -> "ARE")
  if (ALIAS_MAP[normalizedQuery]) {
    const targetIso3 = ALIAS_MAP[normalizedQuery];
    const match = countries.find(c => c.iso3 === targetIso3);
    if (match) return [match];
  }

  return countries.filter(country => {
    // 1. Exact ISO Code Match (high priority)
    if (country.iso2.toLowerCase() === normalizedQuery) return true;
    if (country.iso3.toLowerCase() === normalizedQuery) return true;

    // 2. Name Starts With
    const normName = normalize(country.name);
    if (normName.startsWith(normalizedQuery)) return true;

    // 3. Word match (e.g. "United" matches "United States")
    const words = normName.split(' ');
    if (words.some(w => w.startsWith(normalizedQuery))) return true;

    // 4. Alt Spellings / Native Names
    if (country.altSpellings.some(alt => normalize(alt).startsWith(normalizedQuery))) return true;
    
    return false;
  }).sort((a, b) => {
    // Basic ranking
    const aName = normalize(a.name);
    const bName = normalize(b.name);
    
    // Exact match top
    if (aName === normalizedQuery) return -1;
    if (bName === normalizedQuery) return 1;

    // Starts with top
    const aStarts = aName.startsWith(normalizedQuery);
    const bStarts = bName.startsWith(normalizedQuery);
    if (aStarts && !bStarts) return -1;
    if (!aStarts && bStarts) return 1;

    return a.name.localeCompare(b.name);
  }).slice(0, 5); // Limit results
};
